define('modules/profiles/cards/views/role.bin.view',[
    'client',
    'jquery',
    'jqueryUi',
    'underscore',
    'backbone',
    "marionette",
    'modules/profiles/models/card.model',
    'modules/base/views/base.view',
    'text!modules/profiles/cards/templates/role.bin.template.html'
], function(Prospector,$, jqueryUi, _,Backbone,
            Marionette,
            BoardCardModel,
            BaseView,
            Template) {
    var RoleBinView = BaseView.extend({
        template: _.template(Template),
        tagName: 'span',
       initialize: function(options){ //constructor
            BaseView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = new BoardCardModel(this.parent.model.attributes);
        },
        //logic for getting bin name
        getBinName:function() {
            var arrayBins = [];
            var record = this.model.get('record');
            if (record.bins.length == 1) {
                return record.bins["0"].name;
            } else {
                 for (var i =0; i<record.bins.length; i++) {
                     var name = record.bins[i].name;
                     arrayBins.push(window.utils.getItemAsCommaList(name,i,record.bins.length));
                 }
                 return arrayBins;
            }
        },
        onRender:function(){
            this.$('.roleBin').html(this.getBinName());
        }
    });
    return RoleBinView;
});
